import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { initializeGoogleAnalytics } from './analytics/googleAnalytics';

initializeGoogleAnalytics();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // strict mode triggers state changes twice in dev mode
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
